import { isFeatureAvailable, useGetDevFeatures } from "@components/featureGuard/FeatureGuard"
import { useAppSelector } from "@redux/app/hooks"
import { getUserData } from "@redux/features/userData/userDataSlice"
import { useQuery } from "@tanstack/react-query"
import { requestApi2 } from "@utils/http"
import { PortalFeature, endpoints } from "api"
import { WeekNumbers } from "luxon"

export type BwFishFarmWeekData = {
	year: number
	week: number
	localities: BwFishFarmData[]
}

export type BwFishFarmData = {
	localityNo: number
	localityWeekId: number
	name: string
	hasReportedLice: boolean
	isFallow: boolean
	avgAdultFemaleLice: number
	hasCleanerfishDeployed: boolean
	hasMechanicalRemoval: boolean
	hasSubstanceTreatments: boolean
	hasPd: boolean
	hasIla: boolean
	municipalityNo: string
	municipality: string
	lat: number
	lon: number
	isOnLand: boolean
	inFilteredSelection: boolean
	hasSalmonoids: boolean
	isSlaughterHoldingCage: boolean
}

type FishFarmDataQuery = {
	postData: {
		year: number
		week: WeekNumbers
		orgNo: number | null
	}
	companyName: string | undefined
}
export default function useFishFarmDataQuery(args: FishFarmDataQuery) {
	const queryKey = [
		`queryId=FishFarmData`,
		`endpoints=[${endpoints.getFishInfo.getName()}]`,
		`companyName=${args.companyName}`,
	]
	if (args.postData.orgNo !== null) {
		queryKey.push(`orgNo=${args.postData.orgNo}`)
	}
	const userData = useAppSelector(getUserData)
	const devFeatures = useGetDevFeatures()

	return useQuery({
		queryKey,
		queryFn: async () => {
			if (args.companyName === undefined) {
				throw new Error("Invalid query params")
			}
			if (
				isFeatureAvailable(
					undefined,
					PortalFeature.FISH_FARM,
					args.companyName,
					devFeatures,
					userData.portalMode
				) === false
			) {
				return null
			}
			const fishInfo = await requestApi2(endpoints.getFishInfo, args.postData)
			return fishInfo !== null ? (JSON.parse(fishInfo) as BwFishFarmWeekData) : null
		},
		enabled: args.companyName !== undefined,
		staleTime: 600000,
		refetchInterval: 600000,
	})
}
